// extracted by mini-css-extract-plugin
export default {"bodyBox":"src_bodyBox__e2Umk","header":"src_header__YRfCY","nav":"src_nav__OESvv"};